import api from '@/lib/api';
import { Notification } from '@/types/notification';

export class NotificationService {
  async findAll(): Promise<Notification[]> {
    const response = await api.get<Notification[]>('/notifications');
    return response.data;
  }

  async findUnread(): Promise<Notification[]> {
    const response = await api.get<Notification[]>('/notifications/unread');
    return response.data;
  }

  async markAsRead(id: string): Promise<void> {
    await api.patch(`/notifications/${id}/read`);
  }

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/read-all');
  }

  async remove(id: string): Promise<void> {
    await api.delete(`/notifications/${id}`);
  }

  async getUnreadCount(): Promise<number> {
    const response = await api.get<{ count: number }>('/notifications/unread-count');
    return response.data.count;
  }

  async createExamples(): Promise<{ message: string; count: number }> {
    const response = await api.post<{ message: string; count: number }>('/notifications/create-examples');
    return response.data;
  }

  async getPushPublicKey(): Promise<string | null> {
    const response = await api.get<{ publicKey: string | null }>('/notifications/push-public-key');
    return response.data.publicKey;
  }

  async subscribePush(subscription: PushSubscription): Promise<void> {
    const json = subscription.toJSON();
    await api.post('/notifications/push/subscribe', {
      endpoint: json.endpoint,
      p256dh: json.keys?.p256dh,
      auth: json.keys?.auth,
      userAgent: navigator.userAgent,
    });
  }

  async unsubscribePush(endpoint: string): Promise<void> {
    await api.delete('/notifications/push/subscribe', { data: { endpoint } });
  }

  async sendTestPushVapid(): Promise<void> {
    await api.post('/notifications/test-push/vapid');
  }
}

export const notificationService = new NotificationService();
